import React from 'react';
import { Button } from './ui/button';
import { Shield, Clock, Briefcase, CheckCircle2 } from 'lucide-react';
import { trackCallClick, handleEmailClick } from '../utils/tracking';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleEmailButtonClick = () => {
    trackCallClick(); // Track as conversion attempt
    handleEmailClick('info@harp-solutions.co.uk');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-950/95 via-gray-950/90 to-gray-900/85 z-10"></div>
        <img
          src="https://images.pexels.com/photos/3769162/pexels-photo-3769162.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Professional Engineering"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="animate-fadeIn">
          {/* Main Headline */}
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            <span className="text-white">24/7 Engineering Solutions</span>
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">
              When Every Minute Counts
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-4xl mx-auto leading-relaxed">
            Your trusted partner for Handyman, Air Conditioning, Refrigeration & Plumbing, 
            delivering fast, reliable service across London, Greater London, Essex & Kent.
          </p>

          {/* Supporting Text */}
          <p className="text-lg text-gray-400 mb-12 max-w-2xl mx-auto">
            Fully equipped engineers. Rapid response. No compromise on quality.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <a 
              href="tel:+443301221094"
              className="h-14 px-8 text-lg rounded-xl flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-700 text-white font-medium transition-all duration-300 hover:shadow-2xl hover:shadow-amber-500/40 hover:scale-105"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              Call Now
            </a>
            <Button 
              onClick={scrollToContact}
              className="h-14 px-8 text-lg rounded-xl flex items-center justify-center gap-2 border-2 border-amber-600 text-amber-500 bg-transparent hover:bg-amber-600 hover:text-white font-medium transition-all duration-300 hover:shadow-2xl hover:shadow-amber-500/40"
            >
              Request a Quote
            </Button>
          </div>

          {/* Trust Cues */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            <div className="flex flex-col items-center space-y-2 p-4 bg-gray-900/50 backdrop-blur-sm rounded-lg border border-gray-800 hover:border-amber-600/50 transition-all duration-300">
              <Shield className="w-8 h-8 text-amber-500" />
              <p className="text-sm text-gray-300 font-medium">Fully Certified</p>
            </div>
            <div className="flex flex-col items-center space-y-2 p-4 bg-gray-900/50 backdrop-blur-sm rounded-lg border border-gray-800 hover:border-amber-600/50 transition-all duration-300">
              <CheckCircle2 className="w-8 h-8 text-amber-500" />
              <p className="text-sm text-gray-300 font-medium">Fully Insured</p>
            </div>
            <div className="flex flex-col items-center space-y-2 p-4 bg-gray-900/50 backdrop-blur-sm rounded-lg border border-gray-800 hover:border-amber-600/50 transition-all duration-300">
              <Clock className="w-8 h-8 text-amber-500" />
              <p className="text-sm text-gray-300 font-medium">Fast Response</p>
            </div>
            <div className="flex flex-col items-center space-y-2 p-4 bg-gray-900/50 backdrop-blur-sm rounded-lg border border-gray-800 hover:border-amber-600/50 transition-all duration-300">
              <Briefcase className="w-8 h-8 text-amber-500" />
              <p className="text-sm text-gray-300 font-medium">Residential & Commercial</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
